import * as DEVICE_PROFILE_ACTIONS from '../redux/actions/device-profile-actions';

const state = {
    selectedProfile: null
};

export default (previousState = state, { type, payload }) => {
    switch (type) {
        case DEVICE_PROFILE_ACTIONS.CHANGE_SELECTED_DEVICE_PROFILE:
            return {
                ...previousState,
                selectedProfile: payload
            };
        default:
            return previousState;
    }
};
